import React from "react";
import {FormFeedback, Input} from "reactstrap";

/**
 *
 * @param label
 * @param name
 * @param formik
 * @param type
 * @param placeholder
 * @param rest
 * @returns {JSX.Element}
 * @constructor
 *
 * Usage Example with Extra Props
 * <FormInputField
 *   label="Contact Name"
 *   name="contactName"
 *   formik={customerDetailsFormik}
 *   showValidation={true}
 *   maxLength={30}
 *   autoFocus
 *   disabled={isReadOnly}
 * />
 *
 *  <FormInputField
 *   label="Contact Name"
 *   name="contactName"
 *   showValidation={true}
 *   formik={customerDetailsFormik}
 * />
 *
 * With validation
 * <FormInputField
 *   label="Contact Name"
 *   name="contactName"
 *   formik={customerDetailsFormik}
 *   showValidation={true}
 * />
 *
 * Without validation
 * <FormInputField
 *   label="Optional Note"
 *   name="note"
 *   formik={customerDetailsFormik}
 *   showValidation={false}
 * />
 *
 */

const FormInputField = ({label, name, formik, type = 'text', placeholder = '', showValidation = false, ...rest}) => {
    const { values, handleChange, handleBlur, touched, errors } = formik;

    const hasError = showValidation && touched[name] && !!errors[name];

    return(
        <>
            {label && (
                <label className="form-label" htmlFor={name}>
                    {label}
                </label>
            )}
            <Input
                id={name}
                name={name}
                type={type}
                placeholder={placeholder}
                value={values[name]}
                onChange={handleChange}
                onBlur={handleBlur}
                invalid={hasError}
                {...rest}
            />
            {hasError && <FormFeedback>{errors[name]}</FormFeedback>}
        </>
    );
}

export default FormInputField;
